import { TextMatchTransformer } from '@lexical/markdown';
import { $createTextNode, LexicalNode } from 'lexical';
import {
  $createSuggestionNode,
  $isSuggestionNode,
  $sourceSuggestion,
} from '../../nodes/SuggestionNode';
import { Source } from '../../types';

const VALID_SOURCES: Source[] = ['default', 'note'];

function isValidSource(source: string): source is Source {
  return VALID_SOURCES.includes(source as Source);
}

export const INLINE_SUGGESTION: TextMatchTransformer = {
  type: 'text-match',
  dependencies: [],

  regExp: /<suggestion(?: source="([^"]*)")?>(.*?)<\/suggestion>/,
  importRegExp: /<suggestion(?: source="([^"]*)")?>(.*?)<\/suggestion>/,
  export: (node: LexicalNode, traverseChildren) => {
    if (!$isSuggestionNode(node)) {
      return null;
    }

    const source = $sourceSuggestion(node);
    const output: string[] = [];

    if (source !== 'default') {
      output.push(`<suggestion source="${source}">`);
    } else {
      output.push('<suggestion>');
    }

    output.push(traverseChildren(node));
    output.push('</suggestion>');
    return output.join('');
  },

  replace: (node, match) => {
    const sourceAttr = match[1];
    const textContent = match[2];
    const source: Source = sourceAttr && isValidSource(sourceAttr) ? sourceAttr : 'default';

    const suggestion = $createSuggestionNode(source);
    suggestion.append($createTextNode(textContent));
    node.replace(suggestion);
    suggestion.selectNext();
  },
};
